export default function Footer() {
	return (
		<footer className="flex flex-row justify-between items-center w-full p-2">
			<h6 className="text-sm font-semibold space-x-3 text-gray-700">
				&copy; 2024, Made by{" "}
				<a
					className="text-primary"
					href="https://www.code.id/contact-us"
					target="blank"
				>
					PT. Code Development Indonesia
				</a>
				<span className="text-gray-800 font-normal tracking-tight">
					V 1.0.0
				</span>
			</h6>
		</footer>
	);
}
